import React, { useState } from "react";

type TextViewProps = {
  text: string;
};

const TextView: React.FC<TextViewProps> = ({ text: transcript }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(transcript)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset copied status after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <div
      className={`flex flex-col items-center w-full h-full p-6 border border-gray-300 rounded-lg bg-gray-50 shadow-md`}
      onClick={handleCopy}
      style={{ cursor: "pointer" }} // Indicate it's clickable
    >
      <div
        className={`w-full h-full overflow-y-auto p-4 border border-gray-300 rounded-md bg-white ${
          copied ? "ring-2 ring-green-500" : ""
        }`}
      >
        <pre className="whitespace-pre-wrap break-words text-sm font-mono text-gray-800">
          {transcript}
        </pre>
      </div>
      {copied && (
        <span className="mt-2 text-xs text-green-600">Copied to clipboard!</span>
      )}
    </div>
  );
};

export default TextView;